/**
 * Tracks which UI layers are open. While any blocking layer is open the world is
 * paused (no movement, no clock, no random calls) and keyboard input goes to the UI.
 */
const open = new Set<string>();
const listeners = new Set<() => void>();

export const layers = {
  open(id: string): void {
    open.add(id);
    listeners.forEach((f) => f());
  },
  close(id: string): void {
    open.delete(id);
    // Don't leave focus inside something that just disappeared.
    if (document.activeElement instanceof HTMLElement && document.activeElement !== document.body) document.activeElement.blur();
    listeners.forEach((f) => f());
  },
  isOpen(id: string): boolean {
    return open.has(id);
  },
  blocking(): boolean {
    return open.size > 0;
  },
  onChange(fn: () => void): void {
    listeners.add(fn);
  },
};
